import { gql } from "@apollo/client";
import { EVENT_NODE_FIELDS, EVENT_PAGINATION_FIELDS, EVENT_RESULT_FILTER_METADATA } from "graphql/fragments";

const GET_MISSION_ROLE_EVENTS = gql`
  ${EVENT_NODE_FIELDS}
  ${EVENT_PAGINATION_FIELDS}
  ${EVENT_RESULT_FILTER_METADATA}
  query missionRoleEvents(
    $missionRoleId: ID!
    $sortKey: String
    $sortDirection: String
    $filters: TimelineEventFilter
    $advancedFilters: [AdvancedFilter!]
    $resultFilterMetadata: [String!]
    $paginationInfo: PaginationInfo
  ) {
    missionRoleEvents(
      missionRoleId: $missionRoleId
      sortKey: $sortKey
      sortDirection: $sortDirection
      filters: $filters
      advancedFilters: $advancedFilters
      resultFilterMetadata: $resultFilterMetadata
      paginationInfo: $paginationInfo
    ) {
      ...EventPaginationFields
      filterMetadata {
        ...TimelineEventsResultFilterMetadata
      }
      nodes {
        ...EventNodeFields
      }
    }
  }
`;

export { GET_MISSION_ROLE_EVENTS };
